export function getStoredRoles() {
  try {
    const raw = localStorage.getItem('userRoles');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function getStoredAccesses() {
  try {
    const raw = localStorage.getItem('userAccesses');
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function setUserAuthData({ roles = [], accesses = [] }) {
  localStorage.setItem('userRoles', JSON.stringify(roles));
  localStorage.setItem('userAccesses', JSON.stringify(accesses));
}

export function clearUserAuthData() {
  localStorage.removeItem('userRoles');
  localStorage.removeItem('userAccesses');
}

export function isMarcadorOnly(roles = getStoredRoles()) {
  return roles.length === 1 && roles.includes('MARCADOR');
}

export function hasRole(role, roles = getStoredRoles()) {
  return roles.includes(role);
}

export function hasAnyRole(requiredRoles = [], roles = getStoredRoles()) {
  if (!requiredRoles.length) return false;
  if (!roles.length) return false;
  return requiredRoles.some((r) => roles.includes(r));
}

export function canAccessRoute(route, roles = getStoredRoles(), accesses = getStoredAccesses()) {
  if (route.layout === '/auth') return true;

  const requiredAccesses = route.accesses || [];
  const requiredRoles = route.roles || [];

  if (!requiredAccesses.length && !requiredRoles.length) {
    return false;
  }

  if (!roles.length && !accesses.length) {
    return false;
  }

  if (requiredRoles.length && requiredRoles.some((r) => roles.includes(r))) {
    return true;
  }

  if (requiredAccesses.length && requiredAccesses.some((a) => accesses.includes(a))) {
    return true;
  }

  return false;
}

export function filterRoutesByAccess(routes, roles = getStoredRoles(), accesses = getStoredAccesses()) {
  return routes
    .map((route) => {
      if (route.category && route.items?.length) {
        const items = filterRoutesByAccess(route.items, roles, accesses);
        if (!items.length) return null;
        return { ...route, items };
      }
      return canAccessRoute(route, roles, accesses) ? route : null;
    })
    .filter(Boolean);
}

export function getDefaultRoute(roles = getStoredRoles(), accesses = getStoredAccesses()) {
  if (isMarcadorOnly(roles) && accesses.includes('TIME_CLOCK')) {
    return '/admin/time-clock';
  }
  const routeByAccess = [
    ['BEDELIA_STUDENTS', '/admin/default'],
    ['DASHBOARD', '/admin/dashboard'],
    ['BEDELIA_TEACHERS', '/admin/teaching'],
    ['BEDELIA_REVALIDATIONS', '/admin/revalidations'],
    ['DICTATED_INSCRIPTIONS', '/admin/inscriptions'],
    ['DICTATED_COURSES', '/admin/dictated-courses'],
    ['EXAM_INSCRIPTIONS', '/admin/exam-inscriptions'],
    ['EXAMS', '/admin/exams'],
    ['FINANCE_CURRENT_ACCOUNT', '/admin/current-account'],
    ['PAYROLL_PERIODS', '/admin/payroll'],
    ['LIBRARY_MEDIA', '/admin/library'],
    ['ACADEMIC_STUDIES', '/admin/studies'],
    ['ADMIN_AUDIT', '/admin/audit-log'],
    ['USER_MANAGEMENT', '/admin/user-management'],
    ['TIME_CLOCK', '/admin/time-clock'],
    ['TIME_CLOCK_REPORT', '/admin/time-record-report'],
  ];
  const match = routeByAccess.find(([code]) => accesses.includes(code));
  if (match) return match[1];
  return '/admin/unauthorized';
}
